module.exports = __webpack_public_path__ + "img/2.57d40c5b.jpg";